import React from 'react';
import styled from 'libs/styled';
import { gridMargin } from 'components/wrappers/ContentGridWrapper';
import { above } from '@sportson/core-web/utils/mediaqueries';
import decodeHTMLEntities from '@sportson/core-web/utils/decodeHTMLEntities';
import Button from 'components/Button';

const SubCategoriesWrapper = styled('div')`
    display: flex;
    overflow-x: auto;
    gap: 16px;
    grid-column: 1 / -1;
    margin-left: -${gridMargin.mobile};
    margin-right: -${gridMargin.mobile};
    padding-left: ${gridMargin.mobile};
    padding-right: ${gridMargin.mobile};
    margin-bottom: 14px;

    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
        display: none;
    }

    ${above['desktop.sm']} {
        grid-column: 1 / 9;
        flex-wrap: wrap;
        overflow-x: initial;
        margin-right: -${gridMargin.desktop};
        padding-right: ${gridMargin.desktop};
    }
`;

export type SubCategory = {
    id: number;
    title: string;
    permalink: string;
};

export type SubCategoriesProps = {
    subCategories: SubCategory[];
};

const SubCategories = ({ subCategories }: SubCategoriesProps) => (
    <SubCategoriesWrapper>
        {subCategories.map((subCategory) => (
            <Button key={subCategory.id} url={subCategory.permalink} theme="secondary">
                {decodeHTMLEntities(subCategory.title)}
            </Button>
        ))}
    </SubCategoriesWrapper>
);

export default SubCategories;
